interface AppFreshnessProps {
  /** The freshness text, e.g. "as of 9:33 AM ET", "14 Aug 2026", "Live · after-hours". */
  label: string;
  /**
   * When true the label turns amber with a warning mark — use only when the
   * data is genuinely stale (not for normal, current data).
   */
  stale?: boolean;
}

/**
 * The standard freshness label. Lives in the footer's left slot
 * (`brand-footer__left`) on every app. Muted grey normally; amber with a
 * warning mark when stale. Keeps "how old is this data" in one consistent place.
 */
export function AppFreshness({ label, stale = false }: AppFreshnessProps): JSX.Element {
  return (
    <span className={`app-fresh${stale ? " app-fresh--stale" : ""}`} role="status">
      {stale ? (
        <svg width="12" height="12" viewBox="0 0 14 14" fill="none" aria-hidden="true">
          <path d="M7 1.6 13 12H1L7 1.6Z" stroke="currentColor" strokeWidth="1.2" strokeLinejoin="round" />
          <path d="M7 5.6v3M7 10.2v.2" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
        </svg>
      ) : (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
          <circle cx="6" cy="6" r="4.4" stroke="currentColor" strokeWidth="1.1" />
          <path d="M6 3.6V6l1.7 1" stroke="currentColor" strokeWidth="1.1" strokeLinecap="round" />
        </svg>
      )}
      {label}
    </span>
  );
}
